import { Injectable, NgZone } from "@angular/core";
import { Observable, of, Subject, throwError, timer } from "rxjs";
import { map, catchError, repeatWhen, skip, takeUntil } from "rxjs/operators";
import {
  IHttpErrorPayload,
  HttpRequestPayload,
  IHttpSuccessPayload,
} from "@core/models";
import { HttpProviderService, HttpRequest } from "@fpx/core";
import {
  ICHECKMPINLoginauthResponseModel,
  IcredentialsModel,
  ILoginauthPayLoad,
  ILoginauthResponseModel,
  IMPINLoginauthResponseModel,
  ITwoFactorResponseModel,
} from "./Pre-login.model";
import { AuthService } from "../auth.service";
import { CustomerService } from "../services/customer.service";
import { Router } from "@angular/router";
import { EPreloginServiceCode } from "../common/models/service-code.model";
import { UserService } from "../user.service";
import { NativeStorageService } from "../services/mobile/native-storage.service";
import { CommonService } from "../common.service";
import { ProcessShellService } from "../process-shell/services/process-shell.service";
import { DialogService } from "src/app/fpx-core/services/dialog/dialog.service";
import { ResponsiveService } from "../responsive.service";
import { environment } from "src/environments/environment";
import { Data } from "../DataService";
import { MatDialog } from "@angular/material/dialog";
import { MobileService } from "src/app/mobile.services";
import { DeviceDetectorService } from "ngx-device-detector";
import { Device } from "@ionic-native/device/ngx";
import { ConfirmationComponent } from "../core/components/dialog/confirmation/confirmation.component";
import { IConfirmationDialogData } from "../core/models/dialog.model";
import { FormControlStatus, FormGroup } from "@angular/forms";
declare var cordova: any;
declare var entrust: any;
@Injectable({
  providedIn: "root",
})
export class PreLoginService {
  credentials: IcredentialsModel = null;
  twoFactor: ITwoFactorResponseModel;
  serviceName: string;
  flow: string = "login";
  serviceCode: string;
  showMainHeader: boolean = true;
  selfRegisterHeader: string = "Self Register";
  isCOB: boolean= false;
  currentStage: string = "identifyYourself";
  completedStage: number = -1;
  selfRegisterStages: any = ["identifyYourself", "otp", "resetPassword"];
  refreshTokenService!: RefreshTokenService;
  serviceUp: boolean;
  token: any;
  subFlow: any;
  deviceRegistered: any;
  userRegistered: any;
  authDevice: any;
  nfcProvision: any;
  isMobile: boolean = false;
  formGroup: FormGroup;

  constructor(
    private _dialog: MatDialog,
    private httpProvider: HttpProviderService,
    private _authService: AuthService,
    private _customerService: CustomerService,
    private _router: Router,
    public _userService: UserService,
    private _nativeStorage: NativeStorageService,
    private _commonService: CommonService,
    private _processShellService: ProcessShellService,
    private _dialogService: DialogService,
    private _responsive: ResponsiveService,
    public mobileService: MobileService,
    private device: Device,
    public dataStore: Data,
    private deviceService: DeviceDetectorService,
    private ngZone: NgZone
  ) {
    this.isMobile = this.deviceService.isMobile();
    // this.nfcProvisioning();
  }

  /// need to set from ARX token
  setUserDetails() {}

  setRefreshToken(refreshToken: string) {
    sessionStorage.setItem("refreshToken", refreshToken);
  }

  setToken(loginauth) {
    if (loginauth?.authToken) {
      this.token = loginauth?.authToken;
      this._userService.setToken(loginauth);
    }
  }

  // getCustomerCode() {
  //   return this.customerCode;
  // }

  // setCustomerCode(customerCode) {
  //   sessionStorage.setItem("customerCode", customerCode);
  //   sessionStorage.setItem("userId", customerCode);
  //   this.customerCode = customerCode;
  // }

  setUserCredentials(credentials: IcredentialsModel) {
    // let loginData = JSON.stringify({
    //   username: credentials.username.toUpperCase(),
    //   password: credentials.password,
    // });
    // this._nativeStorage
    //   .storeData("loginData", loginData).then(res => {
    //     console.log("native storage set ~~~~>", res);
    //   }).catch(res => {
    //     console.log("native storage set error");
    //   })

    this.credentials = {
      username: credentials.username,
      password: credentials.password,
    };
  }

  updateProgessTab(currentStage) {
    this.currentStage = currentStage;
    this.completedStage = this.selfRegisterStages.indexOf(currentStage) - 1;
  }

  getPrimaryUser(): Promise<any> {
    return this._nativeStorage.retriveData("registeredUser");
  }

  setPrimaryUser(user: string) {
    this._nativeStorage
      .storeData("registeredUser", user)
      .then((value) => {
        console.log("native storage set ~~~~>", value);
      })
      .catch((reason) => {
        console.log("native storage set error");
      });
  }

  getServiceName() {
    return this.serviceName;
  }
  setServiceName(serviceName) {
    this.serviceName = serviceName;
  }

  getUserTwoFactor() {
    return this.twoFactor;
  }
  setUserTwoFactor(twoFactor: ITwoFactorResponseModel) {
    this.twoFactor = {};
    if (twoFactor?.email) {
      this.twoFactor["email"] = twoFactor.email;
    }
    if (twoFactor?.mobile) {
      this.twoFactor["mobile"] = twoFactor.mobile;
    }
    if (twoFactor?.whatsapp) {
      this.twoFactor["whatsapp"] = twoFactor.whatsapp;
    }
  }

  doWelcome() {
    this._customerService
      .fetchCustomerInfo(this._userService.customerCode)
      .subscribe((res) => {
        this._commonService.hideSpinner();
        this.ngZone.run(() => {
          this._router.navigate(["welcome", "welcomeuser"]);
        });
        // });
        if (
          this._commonService.isHybrid() &&
          this.mobileService.device.platform.toLowerCase() == "android" &&
          this.mobileService.isNFCPresent
        ) {
          var that = this;
          this._nativeStorage
            .retriveData("defaultCardId")
            ?.then((value) => {
              that.nfcWalletConnect();
            })
            .catch((e) => {
              that.getActivationCode();
            });
        } else {
          // this._commonService.hideSpinner();
          // let _data = {
          //     title: "Alert" + "-" + "WALLET_FAILURE",
          //     message: "Device is not compatible for CB Pay.Please try with other android device with NFC capability.",
          //   okLabel:"Close",
          //   cancelLabel:"Close"
          // }
          // const dialogRef = this._dialog.open(ConfirmationComponent, {
          //   data: _data,
          //   panelClass: 'confirmation-dialog',
          //   backdropClass: 'confirmation-dialog-backdrop',
          //   hasBackdrop: true
          // });
          // dialogRef.afterClosed().subscribe(action => {
          //   if (action) {
          //   } else {
          //     this.formGroup.reset('',{emitEvent:false});
          //   }
          // })
        }
      });
  }
  getActivationCode(): void {
    this._commonService.showSpinner();
    var that: any = this;
    var activationCode = "";
    //prod
    //  var activationCodeUrl = "https://api.antelop.io/api/v1/wallets";
    //preprod
    var activationCodeUrl = "https://api.antelop.net/api/v1/wallets";
    var preparationType = "default";
    //var msisdn = "+6753080367";

    var msisdn =
      "+" + this._customerService.getUserProfile().customerMobileNumber;
    var currencyCode = "PGK";
    var settingsProfile = "basic";
    var json = {
      activationCodeUrl: activationCodeUrl,
      preparationType: preparationType,
      msisdn: msisdn,
      currencyCode: currencyCode,
      settingsProfile: settingsProfile,
    };
    entrust.activationCode(json, (arg) => {
      that._commonService.hideSpinner();
      activationCode = arg.slice(2);
      console.log(activationCode);
      // alert(activationCode);
      localStorage.setItem("activationCode", activationCode);
      that.nfcProvisioning();
    }),
      (arg) => {
        console.log(arg);
        that._commonService.hideSpinner();
        // alert(arg);
      };
  }
  nfcProvisioning() {
    //changes for tapnpay sdk integration starts
    //  let activationCode = "178f6d7fe1a806111368cf84cfa47403";
    let activationCode = localStorage.getItem("activationCode");
    if (
      this.isMobile &&
      this.deviceService.os.toLowerCase() == "android" &&
      this.mobileService.isNFCPresent
    ) {
      this._nativeStorage
        .retriveData("nfcProvisioning")
        .then((value) => {
          var nfcProvision = value;
          if (nfcProvision == "true") {
            console.log(nfcProvision);
            this.nfcWalletConnect();
          } else if (nfcProvision == "false") {
            this.nfcWalletProvisioning(activationCode);
            //do nothing
          } else if (nfcProvision == "") {
            this.nfcWalletProvisioning(activationCode);
          }
        })
        .catch((reason) => {
          this.nfcWalletProvisioning(activationCode);
        });
    }
    //changes for tapnpay sdk integration ends
  }
  nfcWalletProvisioning(activationCode) {
    var that = this;
    this._commonService.showSpinner();
    // this._commonService.showSpinner();
    entrust.provisioning(activationCode, sCallback, fCallback);
    function sCallback(arg) {
      that._commonService.hideSpinner();
      // alert(arg);
      let nfcProvision = arg;
      console.log("Walet Provision Success");
      that._nativeStorage
        .storeData("nfcProvisioning", "true")
        .then((value) => {
          that.nfcWalletConnect();
        })
        .catch((reason) => {
          //                that._nativeStorage.storeData("nfcProvisioning", arg);
          // alert(reason);
        });
    }
    function fCallback(arg) {
      // alert(arg);
      console.log("Walet Provision Failed");
      that._commonService.hideSpinner();
      that._nativeStorage
        .storeData("nfcProvisioning", "false")
        .then((value) => {
          that.nfcWalletConnect();
        })
        .catch((reason) => {
          //                that._nativeStorage.storeData("nfcProvisioning", arg);
          // alert(reason);
        });
      // that._commonService.nfcInitiation$.next(true);
    }
  }
  nfcWalletConnect() {
    //  this._commonService.showSpinner();
    var that = this;
    entrust.connect("", sCallback, fCallback);
    function sCallback(arg) {
      // alert(arg);
      console.log("Walet Connection Success");
      that.dataStore.connectionVal = arg;
      localStorage.setItem("walletID", arg);
      //  that._commonService.hideSpinner();
      //  that._commonService.nfcInitiation$.next(true);
    }
    function fCallback(arg) {
      // alert(arg);
      console.log("Walet Connection Failed");
      that.dataStore.connectionVal = "";
      //   that._commonService.hideSpinner();
      //  that._commonService.nfcInitiation$.next(true);
      that.ngZone.run(() => {
        let _data: IConfirmationDialogData = {
          title: "Alert" + "-" + "WALLET_FAILURE",
          message:
            "Wallet connection error. Please try contactless payments later.",
          okLabel: "Close",
          cancelLabel: "Close",
        };
        const dialogRef = that._dialog.open(ConfirmationComponent, {
          data: _data,
          panelClass: "confirmation-dialog",
          backdropClass: "confirmation-dialog-backdrop",
          hasBackdrop: true,
        });
        dialogRef.afterClosed().subscribe((action) => {
          if (action) {
          } else {
            that.formGroup.reset("", { emitEvent: false });
          }
        });
      });
    }
  }

  setFlow(flow) {
    this.flow = flow;
  }
  getFlow() {
    return this.flow;
  }

  setSubFlow(subFlow) {
    this.subFlow = subFlow;
  }

  getSubFlow() {
    return this.subFlow;
  }

  setServiceCode(serviceCode) {
    this.serviceCode = serviceCode;
  }
  getServiceCode() {
    return this.serviceCode;
  }

  getUserCredentials(): Promise<any> {
    return this._nativeStorage.retriveData("loginData");
  }

  login(payload: ILoginauthPayLoad): Observable<ILoginauthResponseModel> {
    const httpRequest: HttpRequest = new HttpRequest();
    httpRequest.setResource("/loginauth");
    httpRequest.setMethod("POST");
    httpRequest.setBody(payload);

    return this.httpProvider.invokeRestApi(httpRequest).pipe(
      map(
        (response: IHttpSuccessPayload<any>) => {
          let loginSetup = this.loginSetup(payload, response);
          return loginSetup;
        },
        catchError((err: IHttpErrorPayload) => {
          return throwError(err);
        })
      )
    );
  }

  loginSetup(payload, response): any {
    const loginResponse: ILoginauthResponseModel = {
      responseBody: response.body,
      status: response.status,
    };
    // this.setCustomerCode(loginResponse.responseBody?.loginauth?.userId);

    this.setUserCredentials({
      username: payload.loginauth.username,
      password: payload.loginauth.password,
    });

    if (response.status == "201" || response.status == 201) {
      // this.getUserCredentials().then(value => {
      //   let loginData = JSON.parse(value);
      //   if (
      //     loginData.username.toUpperCase() !=
      //     payload.loginauth.username.toUpperCase()
      //   ) {

      //   }

      // }).catch(err => {

      // })

      this.setUserTwoFactor({
        email: loginResponse?.responseBody?.loginauth?.twoFactor?.email,
        mobile: loginResponse?.responseBody?.loginauth?.twoFactor?.mobile,
        whatsapp: loginResponse?.responseBody?.loginauth?.twoFactor?.whatsapp,
      });
    } else if (
      (response.status == "200" || response.status == 200) &&
      loginResponse?.responseBody?.loginauth?.expires_in
    ) {
      this.setToken(loginResponse.responseBody.loginauth);
      this.invokeRefreshTokenTimer(
        Number(loginResponse.responseBody.loginauth.expires_in)
      );
    }

    this.setServiceName(EPreloginServiceCode.LOGINAUTH);
    this.setUserDetails();

    return loginResponse;
  }

  checkmpinregistered(
    payload: ILoginauthPayLoad
  ): Observable<ICHECKMPINLoginauthResponseModel> {
    const httpRequest: HttpRequest = new HttpRequest();

    httpRequest.setResource("/checkmpinregistered");
    let username = payload.username
      ? payload.username
      : payload?.loginauth?.username;
    httpRequest.addQueryParameter("userName", this.usernameCaseType(username));
    httpRequest.setMethod("GET");

    return this.httpProvider.invokeRestApi(httpRequest).pipe(
      map((response: any) => {
        console.log("checkMpinRegistered:", response);
        this.deviceRegistered = response.body.deviceRegistered;
        this.userRegistered = response.body.userRegistered;
        this.authDevice = response.body.authDevice;
        return response;
      })
    );
  }

  showAlert(id, title, message: string, button: any[], component: string) {
    let CBXDialogData = {
      title: title,
      message: message,
      button: button,
    };
    this._dialogService.open({
      component: component,
      data: CBXDialogData,
      closeFn: (res) => this.onCloseDialog(id, res),
    });
    //   this.state.isFormSubmitted = false;
  }

  /**
   * if the network down - show offline popup
   * if the network up - show online popup
   */
  showOnlineOfflinePopup() {
    this._dialog.closeAll();
    this._dialogService.open({
      component: "show-online-offline",
      closeFn: (res) => {},
    });
  }

  onCloseDialog(id, res) {
    let os = this._commonService.getDeviceDetails().os.toLowerCase();
    if (id == "mpin") {
      if (res == 1) {
        this._router.navigate(["login", "setMPIN"]);
      } else {
        this._router.navigate(["login"]);
      }
      this._processShellService.triggerFormSubmittedCompleteStatus(true);
    } else if (id == "confirmupdate") {
      this.isCOB = false;
      if (res == 1) {
        if (os == "android") {
          console.log("confirmupdateAndroid");
          window.open("https://play.google.com/store/apps/details?id=pg.com.cbp.mbapp");
        } else if (os == "ios") {
          console.log("confirmupdateIos");
          window.open("https://apps.apple.com/us/app/cbp/id6478291289");
        }
        this._processShellService.triggerFormSubmittedCompleteStatus(true);
      } else {
        this._dialog.closeAll();
      }
    } else if (id == "update") {
      this.isCOB = false;
      if (res == 1) {
        if (os == "android") {
          console.log("UpdateAndroid");
          window.open("https://play.google.com/store/apps/details?id=pg.com.cbp.mbapp");
        } else if (os == "ios") {
          console.log("Updateios");
          window.open("https://apps.apple.com/us/app/cbp/id6478291289");
        }
        this._processShellService.triggerFormSubmittedCompleteStatus(true);
      } else {
        this._dialog.closeAll();
      }
    }

  }

  checkForUpdate(): Observable<any> {
    this.isCOB=true;
    const httpRequest: HttpRequest = new HttpRequest();
    let appVersion = this._commonService.getDeviceDetails().app_version;
    let os = this._commonService.getDeviceDetails().os;

    httpRequest.setResource("/appversion/{appVersion}");
    httpRequest.addPathParameter("appVersion", appVersion);
    httpRequest.addQueryParameter("appType", os.toUpperCase());
    httpRequest.setMethod("GET");

    return this.httpProvider.invokeRestApi(httpRequest).pipe(
      map((response: any) => {
        console.log("checkForUpdate:", response);
        const versionResponse = {
          mandatory: response.body.appversion.mandatory,
          updateAvailable: response.body.appversion.updateAvailable,
          title: response.body.appversion.title,
          description: response.body.appversion.description,
        };

        if (
          versionResponse.mandatory == "1" &&
          versionResponse.updateAvailable == "1"
        ) {
          this.showAlert(
            "confirmupdate",
            versionResponse.title,
            versionResponse.description,
            ["update"],
            "alert"
          );
        } else if (
          versionResponse.mandatory == "0" &&
          versionResponse.updateAvailable == "1"
        ) {
          this.showAlert(
            "update",
            versionResponse.title,
            versionResponse.description,
            ["Update Later", "update"],
            "confirmation"
          );
        }
        return response;
      })
    );
  }

  mpinLogin(
    payload: ILoginauthPayLoad
  ): Observable<IMPINLoginauthResponseModel> {
    const httpRequest: HttpRequest = new HttpRequest();
    httpRequest.setResource("/mpinloginauth");
    httpRequest.setMethod("POST");
    httpRequest.setBody(payload);

    return this.httpProvider.invokeRestApi(httpRequest).pipe(
      map(
        (response: any) => {
          console.log("mpinlogin:", response);

          const loginResponse: IMPINLoginauthResponseModel = {
            responseBody: response.body,
            status: response.status,
          };

          this.setRefreshToken(
            loginResponse.responseBody.mpinloginauth.refreshToken
          );
          // this.setCustomerCode(loginResponse.responseBody.mpinloginauth.userId);

          if (response.status == "201" || response.status == 201) {
            this.setUserTwoFactor({
              email:
                loginResponse.responseBody?.mpinloginauth?.twoFactor?.email,
              mobile:
                loginResponse.responseBody?.mpinloginauth?.twoFactor?.mobile,
              whatsapp:
                loginResponse.responseBody?.mpinloginauth?.twoFactor?.whatsapp,
            });
          } else if (response.status == "200" || response.status == 200) {
            this.setToken(loginResponse.responseBody.mpinloginauth);
            this.invokeRefreshTokenTimer(
              Number(loginResponse.responseBody.mpinloginauth.expires_in)
            );
          }

          this.setServiceName(EPreloginServiceCode.LOGINAUTH);
          this.setUserDetails();
          return loginResponse;
        },
        catchError((err: IHttpErrorPayload) => {
          return throwError(err);
        })
      )
    );
  }

  invokeRefreshTokenTimer(expires_in: number) {
    this.refreshTokenService = new RefreshTokenService(
      (Number(expires_in) - 120) * 1000
    );
    this.refreshTokenService?.observable$.subscribe({
      next: () => {
        console.log("timer");
        if (this._userService.getToken()) {
          this.refreshToken();
        } else {
          this.refreshTokenService.stop();
        }
      },
    });
  }

  refreshToken() {
    let payload = {
      iamrefresh: {
        userName: sessionStorage.getItem("username"),
        refreshToken: sessionStorage.getItem("refreshToken"),
      },
    };
    const httpRequest: HttpRequest = new HttpRequest();
    httpRequest.setResource("/iamtokenrefresh");
    httpRequest.setMethod("POST");
    httpRequest.setBody(payload);

    this.httpProvider.invokeRestApi(httpRequest).subscribe({
      next: (res: IHttpSuccessPayload<any>) => {
        this._userService.setAuthToken(res?.body?.authToken);
        this._userService.setRefreshToken(res?.body?.refreshToken);
      },
    });
  }

  checkApplicationStatus(): Observable<any> {
    const httpRequest: HttpRequest = new HttpRequest();

    httpRequest.setResource("/healthcheck");
    httpRequest.setMethod("GET");
    return this.httpProvider.invokeRestApi(httpRequest).pipe(
      map(
        (response: IHttpSuccessPayload<any>) => {
          const applicationConfigResponse = {
            httpStatus: response?.status,
          };
          return applicationConfigResponse;
        },
        catchError((err: IHttpErrorPayload) => {
          return throwError(err);
        })
      )
    );
  }

  /* getUrlBasedOnEnv() {
    switch (environment.baseURL?.split('//')[1]) {
      case '172.16.22.114:10452': return 'healthcheck';
      case 'ifincloud.io': return 'healthcheck';
      default: return 'healthcheck';
    }
  } */

  iamLogOutUser(): Observable<any> {
    let payload = { userTicket: this._userService.getTicket() };
    const httpRequest: HttpRequest = new HttpRequest();

    httpRequest.setResource("/userlogout");
    httpRequest.setMethod("POST");
    httpRequest.setBody(payload);

    // const httpRequest: HttpRequestPayload = {
    //   resource: "/userlogout",
    //   method: "POST",
    //   body: payload,
    // };

    return this.httpProvider.invokeRestApi(httpRequest).pipe(
      map(
        (response) => {
          return response;
        },
        catchError((err: IHttpErrorPayload) => {
          return throwError(err);
        })
      )
    );
  }

  logout(navPage: any = ["welcome"]) {
    this._dialog?.closeAll();
    if (
      this.token &&
      this.dataStore.isUserLoggedIn() &&
      this._userService.getToken()
    ) {
      this.iamLogOutUser().subscribe();
      this.onLogout(navPage);
    } else {
      this.onLogout(navPage);
    }
  }

  onLogout(navPage: any) {
    this.refreshTokenService?.stop();
    this.setToken(undefined);
    this.dataStore.setUserLoggedIn(false);
    this._userService.logout(navPage);
  }

  killPreviousSession(payload, killPreviousSessionpayload): Observable<any> {
    const httpRequest: HttpRequest = new HttpRequest();

    httpRequest.setResource("/killprevioussession");
    httpRequest.setMethod("POST");
    httpRequest.setBody(killPreviousSessionpayload);

    return this.httpProvider.invokeRestApi(httpRequest).pipe(
      map(
        (response) => {
          let loginSetup = this.loginSetup(payload, response);
          return loginSetup;
          // return response;
        },
        catchError((err: IHttpErrorPayload) => {
          return throwError(err);
        })
      )
    );
  }

  usernameCaseType(userName: string): string {
    return userName?.toUpperCase();
  }
}

export class RefreshTokenService {
  public observable$: Observable<any> = new Observable<any>();
  private readonly _stop = new Subject<void>();
  private readonly _start = new Subject<void>();

  constructor(refreshTime: number) {
    console.log(refreshTime);
    this.observable$ = timer(refreshTime, refreshTime).pipe(
      map(() => {}),
      takeUntil(this._stop),
      repeatWhen(() => this._start)
    );
  }

  start(): void {
    this._start.next();
  }
  stop(): void {
    this._stop.next();
  }
}
